import Authenticated from 'Components/Layouts/Authenticated';
import { MailLink } from "Components/Utilities";

export default function Faq() {

    const faqs = [
        {
            question: 'When is the Fragrance Live Conference?',
            answer: 'The Fragrance Conference is on Tuesday 3rd October and Wednesday 4th October 2023.' +
                'Each store will be allocated a specific day to attend. This can be seen on the ' +
                'registration page.'
        },
        {
            question: 'When does it start and finish?',
            answer: 'The day will start with registration from 09:00 with access to the exhibition area, ' +
                'the plenary will start at 10:00 prompt so please arrange travel to be there no later than 09:45. ' +
                'The day will finish by 16:30, again leave ample time post the event for the booking of trains etc.'
        },
        {
            question: 'Where is the Event?',
            answer: (
                <>
                    The event will be held at:
                    <br />
                    <strong>Coventry Building Society Arena</strong>
                    <br />
                    Judds Lane
                    <br />
                    Longford
                    <br />
                    Coventry
                    <br />
                    CV6 6AQ
                </>
            ),
        },
        {
            question: 'Who is invited?',
            answer: (
                <>
                    A Store Manager along with one Store Team Member are invited to attend the conference.
                    If the Store Manager cannot attend they can invite the Assistant Store Manager
                    or another Store team member instead.
                    Also, providing your store can continue to trade safely, you can make a request for
                    additional places if available. Please email
                    {" "}
                    <MailLink to={"bootsevents@top-b.com"}>
                         {" "} bootsevents@top-b.com
                    </MailLink>
                </>
            ),
        },
        {
            question: 'When do I need to confirm attendance?',
            answer: 'Please confirm attendance as soon as possible and by Friday 22nd September at the latest.'
        },
        {
            question: 'What shall I wear?',
            answer: 'Normal uniform/business dress should be worn.'
        },
        {
            question: 'Can I book accommodation?',
            answer: 'Accommodation is available on the night prior to the event for those that have to ' +
                'travel over 3 hours to get to the venue, this can be requested via the registration' +
                'platform.'
        },
        {
            question: 'How to book travel',
            answer: 'Travel should be booked through Concur and charged to the cost center.' +
                'Each attendee will need to self-book their own travel via Concur using their OneID ' +
                'login details, Store Managers should be able to guide Team Members through the ' +
                'process, communication and guidance is also on BootsLive. ' +
                'For ROI Stores each attendee will need to book their travel through their Stores Administrator.'
        },

        {
            question: 'Will food be provided?',
            answer: 'Yes, all meals will be provided during the event days. Please let us know about any dietary requirements when you register.'
        },
        {
            question: 'How to travel -',
            answer: (
                <ul className={"list-disc list-inside"}>
                    <li>
                        <b>By train: </b>
                        Coventry Arena Train Station- This station is located within walking distance of
                        Coventry Building Society Arena (approx. 5 mins).
                        Coventry Train Station- The railway station is in the city centre and
                        approximately six miles away. Taxis are available outside the station and it is
                        roughly a 10 to 15 minute journey.
                    </li>
                    <li>
                       <b>By air: </b>
                        Birmingham International Airport is a 20 minute drive away
                    </li>
                    <li>
                        <b>By Car: </b>
                        Coventry Building Society Arena is just 800 yards from Junction 3 of the
                        M6 and within easy distance of the M1 and M40. Post code for Sat Nav- CV6
                        6AQ
                        <br />
                        There are 2000 free parking spaces onsite
                    </li>
                </ul>
            ),
        },
    ];

    return (
        <Authenticated bgColor="bg-app-green">
            <h1 className="text-app-blue-light text-4xl my-8 text-center">
                FAQs
            </h1>

            <div className={'p-5 md:p-8'}>
                To help you prepare for the Fragrance Conference 2023 we have answered
                some of your most frequently asked questions.
            </div>

            <div className="bg-white/60 p-5 md:p-8">
                <div className="grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-6">
                    {faqs.map((faq, key) => (
                        <div>
                            <div className={"font-bold"}>
                                {faq.question}
                            </div>

                            <div className={"font-light"}>
                                {faq.answer}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Authenticated>
    )
}
